module.exports = __webpack_public_path__ + "fonts/fa-brands-400.9e13849.ttf";